import { getElementDiv, prepareRender, renderRoadmap, addDisplayTile } from "@/modules/commonRoadmapSmall";
import { IRoadmapSmallClass, IRoadmapSmallProps } from "@/types/RoadmapSmallTypes";
import { IGongBallHistoryType } from "@/types/GameHistoryTypes";

interface IProps extends IRoadmapSmallProps {
	history: IGongBallHistoryType[];
}

export default class M16 extends IRoadmapSmallClass {
	props: IProps;

	render() {
		prepareRender(this); 

		//Obligatory counters
		let currentType = "";

		// Formats this.props.history to desired roadmap
		switch (this.props.filter) {
			case "player-banker": 
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					
					if (item.result === "Player") {
						currentType = "player";
						ele = getElementDiv(this, ["diamond", "blue"], idx, ary);
					} else if (item.result === "Banker") {
						currentType = "banker";
						ele = getElementDiv(this, ["diamond", "red"], idx, ary);
					} else {
						// currentType = "draw";
						return;
					}
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			case "odd-even":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					// var total = item.angka.split(",").reduce((x, y) => (!isNaN(x) ? Number(x) : 0) + (!isNaN(y) ? Number(y) : 0)) % 10;
					const total = item.angka.split(",")
						.map(num => Number(num))
						.reduce((a, b) => a + b) % 10;
					
					if (total % 2) {
						currentType = "odd";
						ele = getElementDiv(this, ["square", "red"], idx, ary);
					} else {
						currentType = "even";
						ele = getElementDiv(this, ["square", "black"], idx, ary);
					}
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			case "small-big":
				this.props.history.forEach((item, idx, ary) => {
					let ele = null;
					const total = item.angka.split(",")
						.map(num => Number(num))
						.reduce((a, b) => a + b) % 10;
					
					if (total <= 4) {
						currentType = "small";
						ele = getElementDiv(this, ["circle", "red"], idx, ary);
					} else {
						currentType = "big";
						ele = getElementDiv(this, ["circle", "black"], idx, ary);
					}
					addDisplayTile(this.roadmapArray, ele, currentType, this);
				});
			break;
			default: return null;
		}

		return renderRoadmap(this);
	}
}
